import { Component, Input, OnInit } from '@angular/core';
import { BaseAgency, UserInfoStateStructure, LOGIN_INFO_REDUCER_NAME, LINE_OF_BUSINESS_ENUM, EntitlementsHelperService, USER_ROLE, ENTITLEMENTS } from '@ptl/account-management';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { BrandingConfigurationService } from '@ptl/brand';
import { CookieService } from 'ngx-cookie-service';
import { ProducerAgencyHelperService } from '../../producer-agency-helper.service';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-plan-advisor-v2-sso',
    templateUrl: './plan-advisor-v2-sso.component.html',
    styleUrls: ['./plan-advisor-v2-sso.component.scss'],
    standalone: false
})

export class PlanAdvisorV2SsoComponent implements OnInit {

  @Input() planAdvisorLabel: string;
  @Input() isRenewal: boolean;
  @Input() customData?: string;

  planAdvisorRenewalSSOUrl: string;
  planAdvisorNewToBlueSSOUrl: string;

  userHasAccess = false;

  loginData: UserInfoStateStructure;
  lob: LINE_OF_BUSINESS_ENUM;

  agencyModernizationPilot: boolean; // true shows button

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private brandService: BrandingConfigurationService,
    private cookieService: CookieService,
    private agencyHelper: ProducerAgencyHelperService,
    private entitlementService: EntitlementsHelperService,
    private authoringMode: AuthoringModeService,
  ) { }

  async ngOnInit() {

    this.lob = await this.entitlementService.getCurrentLobPromise();
    this.loginData = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

    const selectedAgency = this?.loginData?.userInfo?.agencyInfo?.selectedAgencies?.[this.lob];
    const isAuthoringMode = this.authoringMode.getAuthoringMode();
    const hasEntitlement = isAuthoringMode || this.hasEntitlementCheck(selectedAgency);
    this.agencyModernizationPilot = this.checkAgencyAccessList(selectedAgency);
    // TODO: agencyModernizationPilot is temporary during Plan Advisor modernization, remove this logic after full production GOLIVE.

    if (hasEntitlement
      && selectedAgency
      && this.agencyIdentifierExists(selectedAgency)
      && this.agencyModernizationPilot) {
      /**
      * 1) Entitlement must be active
      * 2) Agency must be selected
      * 3) Agency must have an ID
      * 4) Agency must be in Access List
      **/

      this.userHasAccess = true;
      this.prepareToLeave(selectedAgency);

      this.planAdvisorNewToBlueSSOUrl = `${environment.external.engen.planAdvisor.domain}/dashboard/new-to-highmark`;
      this.planAdvisorRenewalSSOUrl = `${environment.external.engen.planAdvisor.domain}/dashboard/renewals`;

    } else {
      this.userHasAccess = false;
    }
  }

  // TODO: can we move this to a common service?
  hasEntitlementCheck(selectedAgency) {
    const selectedAgencyEntitlements = this.getEntitlementsByUserType(selectedAgency);

    let entitlementValue: boolean;

    if (this.isRenewal) {
      if (selectedAgencyEntitlements) {
        for (const entitlement of selectedAgencyEntitlements) {
          if (entitlement.descriptionKey === ENTITLEMENTS.RENEWALS) {
            if (entitlement.hasEntitlement === true) {
              entitlementValue = true;
            }
          }
        }
      }
    } else {
      if (selectedAgencyEntitlements) {
        for (const entitlement of selectedAgencyEntitlements) {
          if (entitlement.descriptionKey === ENTITLEMENTS.SMALL_GRP_QUOTES) {
            if (entitlement.hasEntitlement === true) {
              entitlementValue = true;
            }
          }
        }
      }
    }
    return entitlementValue;
  }
  // TODO: can we move this to a common service?

  getEntitlementsByUserType(selectedAgency) {

    const isInternalUser = this.loginData.basicUserInfo.userType.toLocaleLowerCase() === USER_ROLE.INTERNAL.toLowerCase();

    let entitlementsToReturn = [];
    if (isInternalUser) {
      /**
       * INTERNAL role needs to worry about LOB and [0] agency,
       * other roles do not, because their agencies have entitlements
       */
      switch (this.lob) {
        case LINE_OF_BUSINESS_ENUM.INDIVIDUAL:
          entitlementsToReturn = this?.loginData?.userInfo?.broker360ACAAgencies?.[0]?.entitlements;
        case LINE_OF_BUSINESS_ENUM.SENIOR:
          entitlementsToReturn = this?.loginData?.userInfo?.broker360Agencies?.[0]?.entitlements;
        case LINE_OF_BUSINESS_ENUM.SMALL_GROUP:
          entitlementsToReturn = this?.loginData?.userInfo?.agencies[0]?.entitlements;
      }
    } else {
      entitlementsToReturn = selectedAgency.entitlements;
    }

    return entitlementsToReturn;

  }

  // TODO: can we move this to a common service?
  agencyIdentifierExists(selectedAgency: BaseAgency) {
    const isHmBrandWithAgencyId = !this.brandService.isNonHmBrand() && selectedAgency.agencyId;
    const isNonHmBrandWithValidAgency = this.brandService.isNonHmBrand() && (selectedAgency.agencyId || selectedAgency.agencyPartyId || selectedAgency.agentACSId);
    return isHmBrandWithAgencyId || isNonHmBrandWithValidAgency;
  }

  checkAgencyAccessList(selectedAgency: BaseAgency) {
    if (this.customData?.includes("ALL_AGENCIES") || this.customData?.includes(selectedAgency.agencyId)) {
      return true;
    }

    return false;
  }

  async prepareToLeave(selectedAgency: BaseAgency) {
    const agency_ID = selectedAgency.agencyId || selectedAgency.agencyPartyId || selectedAgency.agentACSId;
    const brandDomain = `.${environment.infrastructure.deploymentDomain}`;
    this.cookieService.set('agencyNumber', this.agencyHelper.padAgencyId(agency_ID), null, '/', brandDomain, true, 'None');
  }

}
